(function () {
    'use strict';

    angular
        .module('elogbooks.admin.permissions-overview')
        .controller('UsersByPermissionController', UsersByPermissionController);

    UsersByPermissionController.$inject = ['$state', '$scope', '$stateParams', '$translate', 'usersCollectionResponse', 'permissionTranslation'];

    function UsersByPermissionController($state, $scope, $stateParams, $translate, usersCollectionResponse, permissionTranslation) {
        const vm = this;

        vm.permissionTranslation = permissionTranslation;
        vm.userCollectionResponse = usersCollectionResponse;
        vm.users = Array.isArray(vm.userCollectionResponse?.users) ? vm.userCollectionResponse.users : [];
        vm.stateParams = $stateParams;

        vm.criteria = {
            usersId: { title: 'ID', type: 'number', value: Number($stateParams.usersId) || null },
            usersName: { title: 'NAME', type: 'text', value: $stateParams.usersName || null },
            usersUsername: { title: 'USERNAME', type: 'text', value: $stateParams.usersUsername || null },
            usersEmail: { title: 'EMAIL_ADDRESS', type: 'text', value: $stateParams.usersEmail || null },
            usersStatus: {
                title: 'STATUS',
                type: 'options',
                value: $stateParams.usersStatus || null,
                multiple: false,
                options: [
                    { title: $translate.instant('ALL'), value: null },
                    { title: $translate.instant('STATUS_DRAFT'), value: 'draft' },
                    { title: $translate.instant('STATUS_TRAINING'), value: 'training' },
                    { title: $translate.instant('STATUS_ACTIVE'), value: 'active' },
                    { title: $translate.instant('STATUS_INACTIVE'), value: 'inactive' }
                ]
            }
        };

        $scope.permissionTranslation = permissionTranslation;

        vm.order = (order) => {
            const override = { usersPage: 1 };
            $stateParams.usersOrder = order;
            $state.go('.', angular.extend({}, $stateParams, override), { reload: 'dashboard.admin.permissions-overview' });
        };
    
        vm.search = function() {
            const override = { usersPage: 1 };
            override.usersId = vm.criteria.usersId.value || null;
            override.usersName = vm.criteria.usersName.value || null;
            override.usersUsername = vm.criteria.usersUsername.value || null;
            override.usersEmail = vm.criteria.usersEmail.value || null;
            override.usersStatus = vm.criteria.usersStatus.value || null;
            $state.go('.', angular.extend({}, $stateParams, override), { reload: 'dashboard.admin.permissions-overview' });
        };
    }
})();
